const IntroSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            At MortgageMoat, we understand that comprehensive cybersecurity and compliance require a multifaceted approach. That's why we collaborate with external specialists who provide services that complement our cybersecurity and risk-management offerings.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            We only refer clients to partners whose work supports regulatory compliance, financial-services requirements, and strong information-security practices. Each partner in our network has been carefully vetted to ensure they meet the high standards our clients expect and deserve.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
